import script from "./NewsPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsPost.vue?vue&type=script&lang=ts&setup=true"

import "./NewsPost.vue?vue&type=style&index=0&id=9490cb2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9490cb2e"]])

export default __exports__